import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Synergie from "./Synergie";
import Teambuilder from "./Teambuilder";
import Teamcomps from "./Teamcomps";
import TeamcompDetails from "./TeamcompDetails";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminTeamcomp from "./AdminTeamcomp"; 
import Helditems from "./Helditems";
import Navbar from "./Navbar";
import TeambuilderAdmin from "./TeambuilderAdmin";
import TeamcompDashboard from "./teamcompDashboard";
import Impressum from "./impressum";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import HowTo from "./howto";
import AdminStatistiks from "./AdminStatistiks";
import Pokemons from "./Pokemons";
import TeamCommunityDetails from "./TeamCommunity";
import TeamCommBuilder from "./TeamCommBuilder";
import AdminCommTeams from "./AdminCommTeams";
import News from "./news";



const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Pokemons" element={<Pokemons />} />
        <Route path="/synergy" element={<Synergie />} />
        <Route path="/Teambuilder" element={<TeamCommBuilder />} />
        <Route path="/teamcomps" element={<Teamcomps />} />
        <Route path="/teamcompdetails/:id" element={<TeamcompDetails />} />
        <Route path="/helditems" element={<Helditems />} /> 
        <Route path="/arceus" element={<div style={{ padding: "20px", color: "white" }}> Arceus Seite im Aufbau...</div>} />
        <Route path="/privatadmin" element={<AdminLogin />} />
        <Route path="/howto" element={<HowTo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/TeamComm" element={<TeamCommunityDetails />} />
        <Route path="/news" element={<News />} />
       
        <Route path="/admindashboard" element={<ProtectedRoute> <AdminDashboard /> </ProtectedRoute>}/>
        <Route path="/statistics" element={<ProtectedRoute> <AdminStatistiks /> </ProtectedRoute>}/>
        <Route path="/privatadmin/teamcomps" element={<ProtectedRoute> <AdminTeamcomp /> </ProtectedRoute>}/>
        <Route path="/privatadmin/teambuilder" element={<ProtectedRoute> <TeambuilderAdmin /> </ProtectedRoute>}/>
        <Route path="/privatadmin/teamcompdashboard" element={<ProtectedRoute> <TeamcompDashboard /> </ProtectedRoute>}/>
        <Route path="/privatadmin/admincommteams" element={<ProtectedRoute> <AdminCommTeams /> </ProtectedRoute>}/>

        
      </Routes>
    </Router>
  );
};

export default App;
